import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { bindActionCreators } from "redux";
import Button from "sushiweb/Button";
import Filter from "sushiweb/Icons/all/Filter";
import { connect } from "react-redux";
import ChangeLogList from "../../components/ConfigChangeLog/ChangeLogList";
import * as CityActions from "../../store/actions/City";
import * as ConfigChangeLogActions from "../../store/actions/ConfigChangeLog";
import * as GenSettingActions from "../../store/actions/GenSetting";
import * as CityPropertyActions from "../../store/actions/CityProperty";
import ChangeLogFilterFormModal from "../../components/ConfigChangeLog/ChangeLogFilterFormModal";
import ErrorMsgs from "../../constants/Errors.json";
import * as UserActions from "../../store/actions/User";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import ListPagination from "../../components/Common/ListPagination";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import InfiniteScrollDropdown from "../../components/Common/InfiniteScrollDropdown";
import ContainerGrid from "sushiweb/ContainerGrid";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  fieldsMargin: {
    margin: "0",
    width: 250,
  },
}));

const ConfigChangeLog = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const allActions = MenuActionsMappings[MenuNames.CONFIG];
  const [Logslist, setLogsList] = useState([]);
  const [heading, setHeading] = useState("");
  const [key, setKey] = useState("relaxation_configuration");
  const [currentPage, setCurrentPage] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [cityId, setCityId] = useState(id);
  const { Source, nextPage, prevPage, activeFilters } = props;
  const [priorityFlag, setPriorityFlag] = useState(true);
  const filterFields = ["event", "start_date", "end_date", "action_by"];

  const getList = () => {
    let filters = {};
    if (key) {
      filters["key"] = key;
    }
    if (cityId) {
      props.resetState({ state: "CityPropertyChangeLog" });
      props
        .getCityPropertyChangeLog(filters, {}, parseInt(cityId))
        .then((response) => {
          setKey(response.key);
          setCityId(cityId);
          setHeading(response.source);
          setLogsList(response.change_logs);
          if (
            filters.hasOwnProperty("key") &&
            filters["key"] === "relaxation_configuration"
          ) {
            props.getCityProperty(parseInt(cityId));
          }
          setPriorityFlag(false);
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    } else {
      props.resetState({ state: "GenSettingChangeLog" });
      props
        .getGenSettingChangeLog(filters)
        .then((response) => {
          setKey(response.key);
          setCityId("");
          setHeading("General Setting");
          setLogsList(response.change_logs);
          if (
            filters.hasOwnProperty("key") &&
            filters["key"] === "relaxation_configuration"
          ) {
            props.getGenSettingRule();
          }
          setPriorityFlag(false);
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    }
  };

  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  const handleNavClick = (action) => {
    const pageRequest = { page: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    if (id) {
      setCityId(id);
      props.resetState({ state: "CityPropertyChangeLog" });
      props
        .getCityPropertyChangeLog(activeFilters, pageRequest, parseInt(id))
        .then((response) => {
          setLogsList(response.change_logs);
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    } else {
      setCityId("");
      props.resetState({ state: "GenSettingChangeLog" });
      props
        .getGenSettingChangeLog(activeFilters, pageRequest)
        .then((response) => {
          setLogsList(response.change_logs);
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFilters)]);

  const getModal = () => {
    const FilterProps = {
      modalState: modalState,
      handleClose: handleClose,
      Source: Source,
      filterFields: filterFields,
      cityId: cityId,
      getList: getList,
      setLogsList: setLogsList,
    };

    switch (modalState) {
      case "filter":
        return (
          <ChangeLogFilterFormModal
            className="ChangeLogFilterFormModal"
            {...FilterProps}
          />
        );
      default:
        return;
    }
  };

  const handleSelectCityChange = (key_name, id) => {
    if (id) {
      history.push(`/city-property/change-logs/${id}`);
    } else {
      history.push(`/gen-setting/change-logs`);
    }
    setPriorityFlag(true);
  };

  const handleSelectKeyChange = (key_name, key) => {
    setKey(key);
  };

  useEffect(() => {
    getList();
  }, [key]);

  return (
    <ChangeLogView>
      <div className="flex mb-20 items-center justify-between">
        <Permission
          requiredPerms={[
            allActions.GET_GEN_SETTING_CHANGE_LOGS,
            allActions.GET_CITY_PROPERTY_CHANGE_LOGS,
            allActions.GET_CITY_PROPERTY_KEYS,
            allActions.GET_GEN_SETTING_KEYS,
          ]}
        >
          <ContainerGrid
            columns="1 1"
            tabletColumns="1"
            mobileColumns="1"
            className={classes.fieldsMargin}
          >
            <div
              class="box"
              className="city-dropdown"
              style={{ minWidth: 180 }}
            >
              <InfiniteScrollDropdown
                handleChange={handleSelectCityChange}
                priorityFlag={1}
                id="CpCityDropdown"
                getActiveList={props.getCityList}
                nextPage={props.nextPageCity}
                resKey="cities"
                keyName="city_id"
                labelKey="city_name"
                getDataLabelKey="city.city_name"
                keyTypeToSet="id"
                label={heading}
                remoteSearchApplicable={true}
                appliedFilters={{}}
                remoteSearchKey="startswith"
              />
            </div>
            <div div class="box" style={{ marginLeft: "1rem", minWidth: 300 }}>
              {cityId ? (
                <>
                  <InfiniteScrollDropdown
                    handleChange={handleSelectKeyChange}
                    priorityFlag={priorityFlag}
                    id="ChangeLogCityDropdown"
                    getActiveList={props.getCityPropertyKeys}
                    nextPage={props.keysNextPage}
                    resKey="keys"
                    keyName="key_name"
                    labelKey="key_name"
                    getDataLabelKey="keys.key_name"
                    keyTypeToSet="key_name"
                    label={key}
                    remoteSearchApplicable={true}
                    appliedFilters={{ id: parseInt(cityId) }}
                    remoteSearchKey="key"
                  />
                </>
              ) : (
                <>
                  <InfiniteScrollDropdown
                    handleChange={handleSelectKeyChange}
                    priorityFlag={priorityFlag}
                    id="ChangeLogCityDropdown"
                    getActiveList={props.getGenSettingKeys}
                    nextPage={props.keysNextPage}
                    resKey="keys"
                    keyName="key_name"
                    labelKey="key_name"
                    getDataLabelKey="keys.key_name"
                    keyTypeToSet="key_name"
                    label={key}
                    remoteSearchApplicable={true}
                    appliedFilters={{}}
                    remoteSearchKey="key"
                  />
                </>
              )}
            </div>
          </ContainerGrid>
          <Button
            onClick={() => handleClick("filter")}
            icon={<Filter />}
            className="sushi-btn"
            id="filterbutton"
            disabled={key === "relaxation_configuration" ? false : true}
          >
            {Object.keys(activeFilters).length > 0 ? (
              <div className="flex items-center">
                <span>Filters</span>
                <h3 className="mb-0 mt-0">{` (${
                  Object.keys(activeFilters).length
                })`}</h3>
              </div>
            ) : (
              "Filters"
            )}
          </Button>
        </Permission>
      </div>
      <Permission
        requiredPerms={[
          allActions.GET_CITY_PROPERTY_CHANGE_LOGS,
          allActions.GET_GEN_SETTING_CHANGE_LOGS,
        ]}
      >
        <ChangeLogList
          Logslist={Logslist}
          setLogsList={setLogsList}
          Source={Source}
          Key={key}
        />
      </Permission>
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage > 0 ? prevPage : -1}
        handleNavClick={handleNavClick}
      />
      {!!modalState && getModal()}
    </ChangeLogView>
  );
};

const mapStateToProps = (state) => {
  const { ConfigChangeLog, City } = state;
  return {
    CityPropertyChangeLog: ConfigChangeLog.CityPropertyChangeLog,
    GenSettingChangeLog: ConfigChangeLog.GenSettingChangeLog,
    nextPageCity: City.nextPage,
    Source: ConfigChangeLog.Source,
    nextPage: ConfigChangeLog.nextPage,
    prevPage: ConfigChangeLog.prevPage,
    activeFilters: ConfigChangeLog.activeChangeLogFilters,
    keysNextPage: ConfigChangeLog.keysNextPage,
    keysPrevPage: ConfigChangeLog.keysPrevPage,
    nextPageCity: City.nextPage,
  };
};

const ChangeLogView = styled.section`
  height: calc(100vh - 200px);
  .MuiAutocomplete-root {
    margin-bottom: unset !important;
  }
`;

const mapDispatchToProps = (dispatch) => {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getCityPropertyChangeLog: bindActionCreators(
      ConfigChangeLogActions.getCityPropertyChangeLog,
      dispatch
    ),
    getGenSettingChangeLog: bindActionCreators(
      ConfigChangeLogActions.getGenSettingChangeLog,
      dispatch
    ),
    getGenSettingRule: bindActionCreators(
      GenSettingActions.getGenSettingRule,
      dispatch
    ),
    getCityProperty: bindActionCreators(
      CityPropertyActions.getCityProperty,
      dispatch
    ),
    getCityPropertyKeys: bindActionCreators(
      ConfigChangeLogActions.getCityPropertyKeys,
      dispatch
    ),
    getGenSettingKeys: bindActionCreators(
      ConfigChangeLogActions.getGenSettingKeys,
      dispatch
    ),
    resetState: bindActionCreators(ConfigChangeLogActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigChangeLog);
